import React , {Component} from 'react'
import styled from 'styled-components'
import SideNav from '../sideNav'


function vitalBanner(ChildComponent){
    return class extends Component{
        render(){
            return(
                <>
                    <SideNav/>
                    <ChildComponent {...this.props} />
                </>
            )
            
        }
    }
}

export default vitalBanner